const propelInit = function() {
const tablesFlip = document.querySelectorAll(
	'.wp-block-table.is-style-flip:not(.wp-block-table--initialized'
);
const tablesStack = document.querySelectorAll(
	'.wp-block-table.is-style-stack:not(.wp-block-table--initialized'
);

tablesFlip.forEach((table) => {
	const firstRowItems = table.querySelectorAll('tbody td');

	firstRowItems.forEach((firstRowItem, index) => {
		const items = table.querySelectorAll(
			'th:nth-child(' +
				(index + 1) +
				'), td:nth-child(' +
				(index + 1) +
				')'
		);

		items.forEach((item) => {
			item.style.setProperty('--mobileRow', index + 1);
		});
	});

	table.classList.add('wp-block-table--initialized');
});

tablesStack.forEach((table) => {
	const headings = table.querySelectorAll('thead th');

	headings.forEach((heading, index) => {
		const items = table.querySelectorAll(
			'td:nth-child(' + (index + 1) + ')'
		);

		items.forEach((item) => {
			const label = document.createElement('div');
			const text = document.createTextNode(heading.innerText);
			label.classList.add('wp-block-table__mobile-label');
			label.appendChild(text);
			item.insertBefore(label, item.firstChild);
		});
	});

	table.classList.add('wp-block-table--initialized');
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['table'] = window.propel.blocks['table'] || {};
window.propel.blocks['table'].script = propelInit;
